module.exports = __webpack_public_path__ + "img/cart_xl.19ceaf46.svg";